// extracted by mini-css-extract-plugin
export default {"page":"TagForm_page__Wdqe2 Wiki_page__G81tY","select-button":"TagForm_select-button__z5TQC"};